import React, { useState, useEffect } from "react";
import p2 from "~/assets/images/botijao-p2.svg";
import p5 from "~/assets/images/botijao-p5.svg";
import p13 from "~/assets/images/Botijao-P13.svg";
import p20 from "~/assets/images/botijao-p20.svg";
import p45 from "~/assets/images/botijao-P45.svg";
import p90 from "~/assets/images/P90.svg";

export default function IconProduct(props) {
  const [icon, setIcon] = useState({
    src: "",
    alt: "",
    styles: null,
  });
  let p2Styles = props.styles ? props.styles.p2 : null;
  let p5Styles = props.styles ? props.styles.p5 : null;
  let p20Styles = props.styles ? props.styles.p20 : null;
  let p45Styles = props.styles ? props.styles.p45 : null;
  let p90Styles = props.styles ? props.styles.p90 : null;
  let p13Styles = props.styles ? props.styles.p13 : null;

  useEffect(() => {
    if(props.productName) {
      var productSelected = props.productName
      .split("")
      .reverse()
      .slice(0, 3)
      .reverse()
      .join()
      .replace(/,/g, "");
      if (productSelected === "P02") {
        setIcon({
          src: p2,
          alt: "Ícone p2",
          styles: p2Styles,
        });
      } else if (productSelected === "P05") {
        setIcon({
          src: p5,
          alt: "Ícone p5",
          styles: p5Styles,
        });
      } else if (productSelected === "P20") {
        setIcon({
          src: p20,
          alt: "Ícone p20",
          styles: p20Styles,
        });
      } else if (productSelected === "P45") {
        setIcon({
          src: p45,
          alt: "Ícone p45",
          styles: p45Styles,
        });
      } else if (productSelected === "P90") {
        setIcon({
          src: p90,
          alt: "Ícone p90",
          styles: p90Styles,
        });
      } else {
        setIcon({
          src: p13,
          alt: "Ícone p13",
          styles: p13Styles,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <img src={icon.src} alt={icon.alt} style={icon.styles} />;
}
